import { Component, Input, OnInit } from '@angular/core';
import { MenuService } from '../../services/menu.service';
import { Menu } from '../../interfaces/menu';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  itemsMenu: Array<Menu> = [];
  @Input() verUrlRepository: any;
  public urlRepository: string = environment.repositoryCode.urlBase;

  constructor(private menuService: MenuService) {
  }

  ngOnInit() {
    this.itemsMenu = this.menuService.getMenu();
  }

  getActive() {
    document.getElementsByClassName('active');
  }

  actionResponsive() {
    if (window.innerWidth <= 992) {
      const element = document.querySelector('.navbar-collapse');
      element?.classList.remove('show');
      const button = document.querySelector('.nav-responsive');
      button?.classList.remove('govco-times');
      button?.classList.add('govco-bars');
    }
  }
}
